<div class="top d-flex align-items-center flex-row">
    <div *ngIf="iconResolved" class="icon ratio ratio-1x1">
        <img class="p-2 ps-0" [src]="iconResolved" alt="icon"/>
    </div>
    <div *ngIf="value" class="value flex-grow-1 d-flex align-items-center">{{value.format(valueFractionDigits)}}</div>
</div>
<div class="title">{{title}}</div>
